import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorLogFileName: {
		id: 'project-create-importer-common.common.error-log-file-name',
		defaultMessage: '{projectName}_import_error_log.zip',
		description: 'File name for the error log',
	},
});
